import { toast } from 'react-toastify';
import { t } from 'react-switch-lang';

export const configureFakeBackend = () => {

};

export function handleResponse(url, requestOptions, withToast = true) {
  return new Promise((resolve, reject) => {
    fetch(url, requestOptions)
      .then((response) => {
        if (!response.ok) {
          switch (response.status) {
            case 401:
            case 400:
              // if (withToast) toast.error(t('network.Need authentification'));
              break;
            case 403:
              if (withToast) toast.error(t('network.Forbidden'));
              break;
            case 404:
              if (withToast) toast.error(t('network.Resourse not found'));
              reject(new Error(t('network.Resourse not found')));
              break;
            default:
              if (withToast) toast.error(t('network.Unknown error'));
              reject(new Error(t('network.Unknown error')));
          }
        } else {
          const json = response.json();
          return json;
        }
      })
      .then((json) => {
        if (json && json.serverJwt) {
          localStorage.setItem('token', json.serverJwt);
          delete json.serverJwt;
          resolve(json);
        }
        resolve(json);
      })
      .catch((error) => reject(error));
  });
}

export function authHeader() {
  // return authorization header with jwt token
  const jwtToken = localStorage.getItem('token');
  if (jwtToken) {
    return { Authorization: `Bearer ${jwtToken}` };
  }
  return {};
}

export function mergeFetchOptions(options) {
  const authHeaders = authHeader();
  return {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    redirect: 'follow',
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders,
    },
    ...options,
  };
}

export function requestGet(url, options = {}, withToast = true) {
  const requestOptions = mergeFetchOptions(options);
  requestOptions.method = 'GET';
  return handleResponse(url, requestOptions, withToast);
}

export function requestPost(url, data = {}, options = {}) {
  const requestOptions = mergeFetchOptions(options);
  requestOptions.method = 'POST';
  requestOptions.body = JSON.stringify(data);
  return handleResponse(url, requestOptions);
}

export function requestDelete(url, data = {}, options = {}) {
  const requestOptions = mergeFetchOptions(options);
  requestOptions.method = 'DELETE';
  requestOptions.body = JSON.stringify(data);
  return handleResponse(url, requestOptions);
}

export function requestPut(url, data = {}, options = {}) {
  const requestOptions = mergeFetchOptions(options);
  requestOptions.method = 'PUT';
  requestOptions.body = JSON.stringify(data);
  return handleResponse(url, requestOptions);
}
